import { Input } from "antd";
import { InputComponentProps } from "components/Form/components/InputComponentProps";
import { Ref } from "react";
import { getLeadingSpaces, getTrailingSpaces } from "utils/utils";

export type TextareaProps = {
    name: string;
    placeholder?: string;
    attributes?: any; // TODO optimize
    inputProps: InputComponentProps<string>;
    inputRef?: Ref<any>;
    className?: string;
};

export const Textarea = ({
    name,
    placeholder,
    inputProps,
    attributes,
    inputRef,
    className,
}: TextareaProps) => {
    const { TextArea } = Input;
    const leadingSpaces = getLeadingSpaces(inputProps.value);
    const trailingSpaces = getTrailingSpaces(inputProps.value);
    // singleLine: keep the field to one row and scroll horizontally instead of
    // wrapping to up to 6 rows. Used for the record-name title so a long name
    // does not consume most of the header height on narrow (mobile) viewports.
    const singleLine = attributes?.singleLine;
    const singleLineClass = singleLine ? "input__field--single-line" : "";
    return (
        <>
            <TextArea
                // singleLine: disable rc-textarea autoSize (its hidden measurer
                // ignores white-space:nowrap and injects an inline
                // overflow:hidden that clips the value and forces a 2-row
                // height). A plain rows={1} textarea lets the CSS below control
                // it: one row tall + horizontal scroll for the full value.
                autoSize={singleLine ? false : { minRows: 1, maxRows: 6 }}
                rows={singleLine ? 1 : undefined}
                onChange={inputProps.onChange}
                onBlur={inputProps.onBlur}
                onFocus={inputProps.onFocus}
                name={name}
                value={inputProps.value}
                placeholder={placeholder}
                className={`input input__field input__field--textarea ${singleLineClass} ${className ?? ""}`}
                readOnly={inputProps.isReadOnly}
                ref={inputRef}
                autoFocus={attributes?.autoFocus}
                onKeyDown={(event) => {
                    if (attributes?.onKeyDown) {
                        attributes.onKeyDown(event);
                    }

                    if (event.key === "Enter" && !event.shiftKey && attributes?.onEnterKey) {
                        event.preventDefault();
                        attributes.onEnterKey((event.target as any).value);
                    }
                }}
            />
            {(leadingSpaces || trailingSpaces) && name === "name" && (
                <div
                    id="inputName"
                    className={`input input__field input__field--textarea background-overlay ${singleLineClass}`}
                >
                    <div className="span-wrapper">
                        <span className="space-background">{leadingSpaces}</span>
                        <span>{inputProps.value.trim()}</span>
                        <span className="space-background">{trailingSpaces}</span>
                    </div>
                </div>
            )}
        </>
    );
};
